import CardTypeA from './CardTypeA/CardTypeA';
import CardTypeB from './CardTypeB/CardTypeB';

export { CardTypeA, CardTypeB };


// WEBPACK FOOTER //
// ./src/uis/components/Banner/CardBanner/Cards/index.js